module.exports = __webpack_public_path__ + "static/img/head.0f65451.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head.jpeg
// module id = N4Ir
// module chunks = 1